import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import ArticleSection from "./components/ArticleSection";
import CTASection from "./components/CTASection";

export default function Home() {
  const seoSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Kakobuy Spreadsheet 2026 - Ultimate Database for Updated Finds & Shopping Lists",
    "description": "Discover thousands of curated Kakobuy Spreadsheet finds, updated product lists, shopping guides, and comparison resources in one powerful platform.",
    "url": "https://kakobuyfinds.sbs/",
    "about": {
      "@type": "Thing",
      "name": "Kakobuy Spreadsheet",
      "description": "A comprehensive database of curated Kakobuy shopping spreadsheets, product finds, and comparison resources."
    },
    "mainEntity": {
      "@type": "ItemList",
      "name": "Kakobuy Spreadsheet Categories",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Shoes" },
        { "@type": "ListItem", "position": 2, "name": "Hoodies & Sweaters" },
        { "@type": "ListItem", "position": 3, "name": "T-Shirts" },
        { "@type": "ListItem", "position": 4, "name": "Jackets" },
        { "@type": "ListItem", "position": 5, "name": "Pants & Shorts" },
        { "@type": "ListItem", "position": 6, "name": "Headwear" },
        { "@type": "ListItem", "position": 7, "name": "Sets" },
        { "@type": "ListItem", "position": 8, "name": "Accessories" },
        { "@type": "ListItem", "position": 9, "name": "Bags" },
        { "@type": "ListItem", "position": 10, "name": "Belts" },
      ]
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the Kakobuy Spreadsheet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Kakobuy Spreadsheet is a comprehensive, community-curated database of product finds, shopping lists, and category-organized items designed to help shoppers discover trending products across multiple categories including sneakers, fashion, accessories, and lifestyle items."
        }
      },
      {
        "@type": "Question",
        "name": "How often is the Kakobuy Spreadsheet updated?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Kakobuy Spreadsheet is updated weekly with new product finds, trending items, and community recommendations to ensure shoppers always have access to the latest and most relevant product listings."
        }
      },
      {
        "@type": "Question",
        "name": "How can I access the Kakobuy Spreadsheet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can access the full Kakobuy Spreadsheet by visiting kaspreadsheet.com, where you will find organized categories, product listings, and comparison tools. Our website provides direct links to all category pages for easy navigation."
        }
      },
      {
        "@type": "Question",
        "name": "Is the Kakobuy Spreadsheet free to use?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, the Kakobuy Spreadsheet is a free resource. Shoppers can browse categories, explore product finds, and use comparison tools without any cost. The platform is community-supported and regularly updated."
        }
      },
      {
        "@type": "Question",
        "name": "What categories are available in the Kakobuy Spreadsheet?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Kakobuy Spreadsheet covers 14+ categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff - providing a complete shopping resource for all needs."
        }
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(seoSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}